import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty } from "src/common/utilities";
import  { PopupColumnsEditorView } from "./popupColumnsEditor-view"
import { ServerConnection } from "src/server/serverConnection";
import { ClassListEditorViewModel } from "src/formBuilder/formBuilder/templateEditor/propertiesPanel/editors/classListEditor/classListEditor-viewModel";
import { getAsNumber } from "src/uicomponents/components/utilities";

export class PopupColumnsEditorViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.columns = ObservableArray.create<column>();
    }
    GetDefaultView(): View <ViewModel> {
        return new PopupColumnsEditorView();
    }
    public getTypeId(): string {
        return "VM-4CEF5B67-35DE-4AD9-ACC6-59F8ADDECD04"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set columns(v: ObservableArray<column>) { this._columns = v; } public get columns(): ObservableArray<column> { return this._columns;} private _columns: ObservableArray<column>;
    public set selectedColumn(v: column) { this._selectedColumn = v; } public get selectedColumn(): column { return this._selectedColumn;} private _selectedColumn: column;
    public set selectedColumnEnumValues(v: ObservableArray<singleColumnCustomEnum>) { this._selectedColumnEnumValues = v; } public get selectedColumnEnumValues(): ObservableArray<singleColumnCustomEnum> { return this._selectedColumnEnumValues;} private _selectedColumnEnumValues: ObservableArray<singleColumnCustomEnum>;
    
    public processes : process[];
    async loadData(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/BpmsRawDataServices/GetAllEnumerationsInProcesses',{});
            this.processes = result.Processes.map(x=>{
                let r = new process(this);
                r.id = x.ProcessId;
                r.name = x.Name;
                r.enums.update(...x.Enums.map(q=>{
                    let e = new enums(r);
                    e.name = q.Name;
                    return e
                }));
                return r;
            })
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    addColumn(){
        let c = new column(this);
        c.index = this.columns.length +1;
        this.columns.push(c);
    }
    removeColumn(column:column){
        this.columns.remove(column);
    }
    
    closePopup(result?: any) {
    }
    
    loadColumns(value: string) {
        this.columns.clear();
        if(stringIsNullOrEmpty(value)){
            return;
        }
        let json = JSON.parse(value);
        this.columns.update(...json.map(x=>{
            let c = new column(this);
            c.index = x.index;
            c.title = x.title;
            c.fieldName = x.fieldName;
            c.typeSelector.selectById(x.type);
            c.selectedProcess = c.processes.filter(q=>q.id==x.processId).at(0);
            c.selectedEnum = c.enums.filter(q=>q.name==x.enumName).at(0);
            c.classListEditor.setValue(x.classList ?? '');
            c.Style = x.stylesList ?? '';
            c.stringColumnTableName = x.stringColumnTableName;
            c.stringColumnFieldName = x.stringColumnColumnName;
            if(x.customEnums){
                c.customEnums.update(... x.customEnums.map((e,i) => {
                    let customEnum = new singleColumnCustomEnum(c);
                    customEnum.name = e.name;
                    customEnum.order = i+1;
                    customEnum.value = e.value;
                    customEnum.minValue = e.minValue;
                    customEnum.maxValue = e.maxValue;
                    return customEnum; 
                }));
            }
            return c;
        }))
    }

    updateIndices(column:column){
        this.columns.forEach(x=>{
            if(x.index>=column.index && x!=column){
                x.index = x.index +1;
            }
        });
        this.columns.sort((x,y)=>(x.index-y.index));
        this.columns.forEach((x,i)=>{
            x.index = i+1;
        })
    }
    confirm(){
        this.columns.sort((x,y)=>(x.index-y.index));
        let result = JSON.stringify(this.columns.map(x=>{
            return {
                index : x.index,
                title : x.title,
                fieldName : x.fieldName,
                type : x.typeSelector.selectedItem.id,
                processId : x.selectedProcess?.id,
                enumName : x.selectedEnum?.name,
                classList : x.classListEditor.getValue(),
                stylesList : x.Style,
                stringColumnTableName : x.isString ? x.stringColumnTableName : undefined,
                stringColumnColumnName : x.isString ? x.stringColumnFieldName : undefined,
                customEnums : x.customEnums?.map(q=>{
                    return {
                        name : q.name,
                        value : q.value,
                        minValue : q.minValue,
                        maxValue : q.maxValue
                    }
                }) ?? []
            }
        }));
        this.closePopup(result);
    }
    back(){
        this.closePopup();
    }

    selectColumn(column: column) {
        this.selectedColumn = column;
        this.selectedColumnEnumValues = column.customEnums;
    }
    orderEnumValues(){
        if(this.selectedColumnEnumValues && this.selectColumn)
            this.selectedColumnEnumValues.sort((x,y)=>x.order-y.order);
    }

    addCustomEnum(){
        if(this.selectedColumnEnumValues && this.selectedColumn)
            this.selectedColumnEnumValues.push(new singleColumnCustomEnum(this.selectedColumn));
    }
}

export class column extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:PopupColumnsEditorViewModel) {
        super(parent);
        this.customEnums = ObservableArray.create<singleColumnCustomEnum>();
        this.typedParent = parent;
        this.typeSelector = new typeSelector(this);
        this.isEnum = false;
        this.typeSelector.onSelectionChanged = x=>{
            this.isEnum = x.id==='enumcolumn';
            this.isString = x.id==='stringcolumn'
        }
        this.processes = ObservableArray.create<process>();
        this.enums = ObservableArray.create<enums>();
        this.processes.update(...this.typedParent.processes);
        this.classListEditor = new ClassListEditorViewModel(this);
    }
    private typedParent: PopupColumnsEditorViewModel;

    public set Style(v: string) { this._Style = v; } public get Style(): string { return this._Style;} private _Style: string;
    public set classListEditor(v: ClassListEditorViewModel) { this._classListEditor = v; } public get classListEditor(): ClassListEditorViewModel { return this._classListEditor;} private _classListEditor: ClassListEditorViewModel;
    public set customEnums(v: ObservableArray<singleColumnCustomEnum>) { this._customEnums = v; } public get customEnums(): ObservableArray<singleColumnCustomEnum> { return this._customEnums;} private _customEnums: ObservableArray<singleColumnCustomEnum>;
    
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    public set fieldName(v: string) { this._fieldName = v; } public get fieldName(): string { return this._fieldName;} private _fieldName: string;
    public set typeSelector(v: typeSelector) { this._typeSelector = v; } public get typeSelector(): typeSelector { return this._typeSelector;} private _typeSelector: typeSelector;
    public set isEnum(v: boolean) { this._isEnum = v; } public get isEnum(): boolean { return this._isEnum;} private _isEnum: boolean;
    public set isString(v: boolean) { this._isString = v; } public get isString(): boolean { return this._isString;} private _isString: boolean;
    public set processes(v: ObservableArray<process>) { this._processes = v; } public get processes(): ObservableArray<process> { return this._processes;} private _processes: ObservableArray<process>;
    public set stringColumnTableName(v: string) { this._stringColumnTableName = v; } public get stringColumnTableName(): string { return this._stringColumnTableName;} private _stringColumnTableName: string;
    public set stringColumnFieldName(v: string) { this._stringColumnFieldName = v; } public get stringColumnFieldName(): string { return this._stringColumnFieldName;} private _stringColumnFieldName: string;
    public set isSelected(v: boolean) { this._isSelected = v; } public get isSelected(): boolean { return this._isSelected;} private _isSelected: boolean;
    
    public set enums(v: ObservableArray<enums>) { this._enums = v; } public get enums(): ObservableArray<enums> { return this._enums;} private _enums: ObservableArray<enums>;
    public set selectedProcess(v: process) { 
        this._selectedProcess = v; 
        if(v){
            this.enums.update(...v.enums);
        }else{
            this.enums.clear();
        }
    } public get selectedProcess(): process { return this._selectedProcess;} private _selectedProcess: process;
    public set selectedEnum(v: enums) { this._selectedEnum = v; } public get selectedEnum(): enums { return this._selectedEnum;} private _selectedEnum: enums;
    
    updateIndices(){
        this.typedParent.updateIndices(this);
    }
    remove(){
        this.typedParent.removeColumn(this);
    }

    select(){
        this.typedParent.selectColumn(this);
    }

    removeEnumValue(arg0: singleColumnCustomEnum) {
        this.customEnums.remove(arg0);
    }
}

export class typeSelector extends SelectorBaseViewModel<idName>{
    protected loadData(): Promise<idName[]> {
        return Promise.resolve([
            new idName(this,'stringcolumn','string'),
            new idName(this,'numbercolumn','number'),
            new idName(this,'enumcolumn','enum'),
            new idName(this,'boolcolumn','bool'),
            new idName(this,'datecolumn','date'),
            new idName(this,'emptycolumn','empty'),

        ]);
    }

}
export class idName extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,id:string,name:string) {
        super(parent);
        this.id = id;
        this.title = name;
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
    
}

export class process extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.enums = ObservableArray.create<enums>();
    }
    
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set enums(v: ObservableArray<enums>) { this._enums = v; } public get enums(): ObservableArray<enums> { return this._enums;} private _enums: ObservableArray<enums>;
        
}

export class enums extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
}

export class singleColumnCustomEnum extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:column) {
        super(parent);
        this.typedParent = parent;
    }
    private typedParent : column;
    public set name(v: string) { this._name = v } public get name(): string { return this._name;} private _name: string;
    public set order(v: number) { this._order = getAsNumber(v,true); } public get order(): number { return this._order;} private _order: number;
    public set value(v: number) { this._value = getAsNumber(v,true); } public get value(): number { return this._value;} private _value: number;
    public set minValue(v: number) { this._minValue = getAsNumber(v,true); } public get minValue(): number { return this._minValue;} private _minValue: number;
    public set maxValue(v: number) { this._maxValue = getAsNumber(v,true); } public get maxValue(): number { return this._maxValue;} private _maxValue: number;

    removeEnumValue(){
        this.typedParent.removeEnumValue(this);
    }
}